import LegalLayout from '../components/legal/LegalLayout';

export default function TermsOfService() {
  return (
    <LegalLayout 
      title="Nutzungsbedingungen" 
      lastUpdated="15. Februar 2026"
    >
      <section className="space-y-8">
        <div>
          <h2 className="text-2xl font-bold text-white mb-4">1. Geltungsbereich</h2>
          <p className="text-gray-300 leading-relaxed mb-4">
            Diese Nutzungsbedingungen gelten für die Nutzung der Azrefy-App und der damit verbundenen Dienste. 
            Durch die Nutzung von Azrefy erklären Sie sich mit diesen Bedingungen einverstanden.
          </p>
          <p className="text-gray-300 leading-relaxed mb-4">
            Azrefy ist eine kostenlose Finanz-Management-App, die Ihnen hilft, Ihre Finanzen zu überwachen, 
            zu analysieren und zu optimieren. Die App wird "wie besehen" bereitgestellt.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-white mb-4">2. Registrierung und Nutzerkonto</h2>
          
          <h3 className="text-xl font-semibold text-white mb-3">2.1 Voraussetzungen</h3>
          <p className="text-gray-300 leading-relaxed mb-4">
            Zur Nutzung von Azrefy müssen Sie:
          </p>
          <ul className="list-disc list-inside text-gray-300 space-y-2 mb-4 ml-4">
            <li>Mindestens 18 Jahre alt sein</li>
            <li>Einen Wohnsitz in Deutschland haben</li>
            <li>Über ein gültiges Bankkonto bei einer unterstützten deutschen Bank verfügen</li>
            <li>Die technischen Voraussetzungen erfüllen (kompatibles Smartphone/Tablet)</li>
          </ul>

          <h3 className="text-xl font-semibold text-white mb-3">2.2 Verantwortlichkeiten</h3>
          <p className="text-gray-300 leading-relaxed mb-4">
            Sie sind verantwortlich für:
          </p>
          <ul className="list-disc list-inside text-gray-300 space-y-2 mb-4 ml-4">
            <li>Die Geheimhaltung Ihrer Zugangsdaten</li>
            <li>Alle Aktivitäten, die über Ihr Konto erfolgen</li>
            <li>Die Richtigkeit der von Ihnen bereitgestellten Informationen</li>
            <li>Die Sicherheit Ihres Geräts</li>
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-white mb-4">3. Leistungsbeschreibung</h2>
          
          <h3 className="text-xl font-semibold text-white mb-3">3.1 Funktionen</h3>
          <p className="text-gray-300 leading-relaxed mb-4">
            Azrefy bietet folgende Hauptfunktionen:
          </p>
          <ul className="list-disc list-inside text-gray-300 space-y-2 mb-4 ml-4">
            <li><strong className="text-white">Kontoverknüpfung:</strong> Sichere Verbindung zu deutschen Banken über PSD2-Schnittstellen</li>
            <li><strong className="text-white">Transaktionsübersicht:</strong> Übersichtliche Darstellung aller Kontobewegungen</li>
            <li><strong className="text-white">KI-Analysen:</strong> Intelligente Auswertung Ihrer Ausgabenmuster</li>
            <li><strong className="text-white">Spartipps:</strong> Personalisierte Empfehlungen zur Optimierung Ihrer Finanzen</li>
            <li><strong className="text-white">Dispo-Warnungen:</strong> Proaktive Benachrichtigungen zur Vermeidung von Überziehungen</li>
          </ul>

          <h3 className="text-xl font-semibold text-white mb-3">3.2 Keine Finanzberatung</h3>
          <div className="bg-yellow-900/20 border border-yellow-500/30 rounded-xl p-6 mb-4">
            <p className="text-gray-300 leading-relaxed">
              <strong className="text-yellow-400">Wichtiger Hinweis:</strong> Azrefy stellt keine Finanzberatung dar. 
              Die bereitgestellten Informationen und Tipps sind allgemeiner Natur und ersetzen keine professionelle 
              Finanzberatung. Für spezifische Finanzentscheidungen konsultieren Sie bitte einen qualifizierten Berater.
            </p>
          </div>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-white mb-4">4. Datensicherheit und Datenschutz</h2>
          
          <h3 className="text-xl font-semibold text-white mb-3">4.1 Lokale Datenspeicherung</h3>
          <p className="text-gray-300 leading-relaxed mb-4">
            Azrefy speichert alle finanziellen Daten lokal auf Ihrem Gerät. Wir übertragen keine Kontostände, 
            Transaktionen oder Banking-Zugangsdaten an unsere Server. Die Datenverarbeitung erfolgt ausschließlich 
            auf Ihrem Gerät.
          </p>

          <h3 className="text-xl font-semibold text-white mb-3">4.2 Verschlüsselung</h3>
          <p className="text-gray-300 leading-relaxed mb-4">
            Alle sensiblen Daten werden verschlüsselt gespeichert. Die Kommunikation mit Ihrer Bank erfolgt über 
            sichere, verschlüsselte Verbindungen gemäß den PSD2-Richtlinien.
          </p>

          <h3 className="text-xl font-semibold text-white mb-3">4.3 Datenlöschung</h3>
          <p className="text-gray-300 leading-relaxed mb-4">
            Sie können jederzeit alle Ihre Daten aus der App löschen. Nach der Deinstallation der App werden alle 
            lokal gespeicherten Daten automatisch vom Gerät entfernt.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-white mb-4">5. Kostenlose Nutzung</h2>
          <p className="text-gray-300 leading-relaxed mb-4">
            Azrefy ist vollständig kostenlos. Es fallen keine Abonnementgebühren, versteckte Kosten oder 
            In-App-Käufe an. Die Nutzung aller Funktionen ist dauerhaft kostenfrei.
          </p>
          <p className="text-gray-300 leading-relaxed mb-4">
            Wir behalten uns das Recht vor, in Zukunft optionale Premium-Funktionen einzuführen, jedoch wird 
            der Kerndienst immer kostenlos bleiben.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-white mb-4">6. Haftungsausschluss</h2>
          
          <h3 className="text-xl font-semibold text-white mb-3">6.1 Verfügbarkeit</h3>
          <p className="text-gray-300 leading-relaxed mb-4">
            Wir bemühen uns um eine hohe Verfügbarkeit der App, können aber keine ununterbrochene Verfügbarkeit 
            garantieren. Wartungsarbeiten können zu temporären Einschränkungen führen.
          </p>

          <h3 className="text-xl font-semibold text-white mb-3">6.2 Datengenauigkeit</h3>
          <p className="text-gray-300 leading-relaxed mb-4">
            Wir übernehmen keine Gewähr für die Vollständigkeit und Richtigkeit der von Banken bereitgestellten 
            Daten. Fehler in den Bankdaten werden von der App übernommen und können zu fehlerhaften Analysen führen.
          </p>

          <h3 className="text-xl font-semibold text-white mb-3">6.3 Haftungsbegrenzung</h3>
          <p className="text-gray-300 leading-relaxed mb-4">
            Azrefy haftet nur für Schäden, die durch vorsätzliches oder grob fahrlässiges Verhalten verursacht wurden. 
            Die Haftung für leichte Fahrlässigkeit ist ausgeschlossen, soweit nicht die Verletzung wesentlicher 
            Vertragspflichten betroffen ist.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-white mb-4">7. Urheberrecht</h2>
          <p className="text-gray-300 leading-relaxed mb-4">
            Alle Inhalte der Azrefy-App, einschließlich Design, Texte, Grafiken und Software, sind urheberrechtlich 
            geschützt. Die Nutzung ist ausschließlich für den persönlichen, nicht-kommerziellen Gebrauch gestattet.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-white mb-4">8. Änderungen der Nutzungsbedingungen</h2>
          <p className="text-gray-300 leading-relaxed mb-4">
            Wir behalten uns das Recht vor, diese Nutzungsbedingungen jederzeit zu ändern. Über wesentliche 
            Änderungen werden Sie per E-Mail oder über die App informiert. Die fortgesetzte Nutzung nach 
            Änderungen gilt als Zustimmung zu den neuen Bedingungen.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-white mb-4">9. Kündigung</h2>
          <p className="text-gray-300 leading-relaxed mb-4">
            Sie können die Nutzung von Azrefy jederzeit ohne Angabe von Gründen beenden, indem Sie die App 
            deinstallieren und Ihr Konto löschen. Wir können Ihr Konto bei Verstößen gegen diese 
            Nutzungsbedingungen sperren oder löschen.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-white mb-4">10. Schlussbestimmungen</h2>
          <p className="text-gray-300 leading-relaxed mb-4">
            Es gilt das Recht der Bundesrepublik Deutschland. Gerichtsstand ist Freiburg im Breisgau. 
            Sollten einzelne Bestimmungen dieser Nutzungsbedingungen unwirksam sein, bleibt die Wirksamkeit 
            der übrigen Bestimmungen davon unberührt.
          </p>
        </div>

        <div className="bg-blue-900/20 border border-blue-500/30 rounded-xl p-6">
          <p className="text-gray-300 leading-relaxed">
            <strong className="text-white">Bei Fragen kontaktieren Sie uns:</strong><br />
            E-Mail: hello@azrefy.com<br />
            Azrefy, Freiburg im Breisgau, Deutschland
          </p>
        </div>
      </section>
    </LegalLayout>
  );
}
